function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_42_00000093874794412206051940000004147297232082398395_",
  transform: "translate(1.565)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_41_00000180338724315737294190000011506227800526238391_"
}, /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_25_00000100364584021064158400000001003885937685835412_",
  d: "M9.9,23.2c-4.9,0-7.7-3.8-7.7-10.2 S5.1,2.8,9.9,2.8c2.6-0.2,5.1,0.8,6.9,2.8c0.5,0.6,0.3,1.4-0.3,1.9c-0.6,0.5-1.4,0.3-1.9-0.3l0,0c-1.3-1.2-3-1.8-4.7-1.7 c-4.4,0-5,4.7-5,7.5s0.7,7.5,5,7.5c1.8,0.1,3.5-0.5,4.8-1.7c0.5-0.6,1.3-0.7,1.9-0.2c0.6,0.5,0.7,1.3,0.2,1.9 C15.1,22.3,12.5,23.3,9.9,23.2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_44_00000121265564801512963370000013981464076087767458_",
  transform: "translate(0 2.589)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_43_00000152951129935639984070000003715737685050177455_"
}, /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_26_00000111899036426085893320000018306840786644731284_",
  d: "M13.3,9.1h-12C0.6,9.1,0,8.5,0,7.8 s0.6-1.4,1.4-1.4h12c0.7,0,1.4,0.6,1.4,1.4S14.1,9.1,13.3,9.1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_46_00000018197860055909571790000014393086570055704749_",
  transform: "translate(0 4.766)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_45_00000102505091041418167760000006859870142009389225_"
}, /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_27_00000167387017875763837810000009942816373650059678_",
  d: "M13.3,12.2h-12c-0.7,0-1.4-0.6-1.4-1.4 s0.6-1.4,1.4-1.4h12c0.7,0,1.4,0.6,1.4,1.4S14.1,12.2,13.3,12.2z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,16.6h-0.3c-0.4,0-0.7-0.3-0.7-0.7v-6c0-0.4,0.3-0.7,0.7-0.7h0.3c0.4,0,0.7,0.3,0.7,0.7v6 C23.1,16.4,22.8,16.6,22.5,16.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7,13.1v-0.3c0-0.4,0.3-0.7,0.7-0.7h6c0.4,0,0.7,0.3,0.7,0.7v0.3c0,0.4-0.3,0.7-0.7,0.7h-6C19,13.8,18.7,13.5,18.7,13.1 z"
}));

function SvgAddPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPay);
export default __webpack_public_path__ + "static/media/addPay.7f73376b.svg";
export { ForwardRef as ReactComponent };